import {useState, useCallback, useMemo} from 'react';
import {Autocomplete, ListBoxOptionType} from '@flixbus/honeycomb-react';
import {CountryNameAutocompleteProps} from './CountryNameAutocomplete.types';
import {countriesList} from '../../constant/countriesList';

const CountryNameAutocomplete: React.FC<CountryNameAutocompleteProps> = ({
  countryName,
  onSelected,
  valid,
  errorMessage
}) => {
  const [filteredOptions, setFilteredOptions] = useState<ListBoxOptionType[]>(
    []
  );
  const countryOptions = useMemo(
    () =>
      countriesList.map(country => ({
        title: country.name,
        value: country.name
      })),
    []
  );

  const handleDebounce = useCallback(
    async inputValue => {
      const searchedText = inputValue.toLowerCase();

      if (!searchedText) {
        setFilteredOptions([]);
        return [];
      }

      const filteredCountries = countryOptions.filter(country =>
        country.title.toLowerCase().startsWith(searchedText)
      );
      setFilteredOptions(filteredCountries);

      return filteredCountries;
    },
    [countryOptions]
  );

  const handleChange = useCallback(
    e => onSelected(e.target.value),
    [onSelected]
  );

  const handleSelect = useCallback(
    selectedOptions => onSelected(selectedOptions[0]?.title),
    [onSelected]
  );

  const renderOption = useCallback(option => option.title, []);

  return (
    <Autocomplete
      comboboxProps={{
        label: 'Country',
        infoError: errorMessage ?? '',
        valid,
        onChange: handleChange,
        'aria-label': 'Country'
      }}
      options={filteredOptions}
      inputValue={countryName}
      listBoxProps={{
        optionsToDisplay: 5,
        optionProps: option => ({
          renderOption: () => renderOption(option)
        })
      }}
      onDebounce={handleDebounce}
      onChange={handleSelect}
    />
  );
};

export default CountryNameAutocomplete;
